import { C, STEP_BASED } from "../constants";
import { toDisplayWeight, toDisplayDist, weightLabel, distLabel } from "../utils/units";
import { Badge } from "./ui";
import { CardioIcon } from "./icons/CardioIcons";

export function WorkoutRow({ w, settings }) {
  const isS    = w.type === "strength";
  const isStep = STEP_BASED.includes(w.cardioType);
  const wDisp  = isS ? toDisplayWeight(w.weight, settings.weightUnit) : 0;
  const dDisp  = !isS && !isStep ? toDisplayDist(w.distance, settings.distUnit) : w.distance;
  const dLbl   = distLabel(w.cardioType, settings.distUnit);

  return (
    <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 10, padding: "13px 17px", display: "flex", alignItems: "center", gap: 13 }}>
      <div style={{ width: 36, height: 36, borderRadius: 9, flexShrink: 0, background: isS ? "#5c5e60" : "#3a5070", display: "flex", alignItems: "center", justifyContent: "center" }}>
        {isS ? (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="1"    y="8"   width="3"   height="4"  rx="1" fill="#f0eeeb"/>
            <rect x="3"    y="6"   width="2.5" height="8"  rx="1" fill="#f0eeeb"/>
            <rect x="14.5" y="6"   width="2.5" height="8"  rx="1" fill="#f0eeeb"/>
            <rect x="16"   y="8"   width="3"   height="4"  rx="1" fill="#f0eeeb"/>
            <rect x="5.5"  y="9"   width="9"   height="2"  rx="1" fill="#f0eeeb"/>
          </svg>
        ) : (
          <CardioIcon cardioType={w.cardioType} />
        )}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 3 }}>
          <span style={{ fontWeight: 700, fontSize: 14, color: C.text }}>{w.name}</span>
          <Badge color={isS ? "accent" : "blue"}>{isS ? w.muscleGroup : w.cardioType}</Badge>
        </div>
        <div style={{ color: C.muted, fontSize: 12 }}>
          {isS
            ? `${w.sets} sets × ${w.reps} reps${w.weight > 0 ? ` @ ${wDisp} ${weightLabel(settings.weightUnit)}` : " (bodyweight)"}`
            : `${w.duration} min · ${isStep ? `${w.distance.toLocaleString()} steps` : `${dDisp} ${dLbl}`} · ${w.calories} kcal`}
        </div>
      </div>
      <div style={{ color: C.muted, fontSize: 11, flexShrink: 0 }}>
        {new Date(w.date + "T12:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric" })}
      </div>
    </div>
  );
}
